import React from 'react';
import {Avatar, Box, Chip, Stack, Typography} from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import UserAvatar from '../../../components/UserAvatar';
import {generateUserColor} from '../../../components/prosemirror-editor/helpers/utils/users';

const AI_AUTHOR = {
    uid: 'ai',
    displayName: 'AI Assistant',
    isAI: true,
};

/**
 * Author chips for preview (matches legacy ReportMetadata badge style).
 */
export default function PreviewAuthorBadges({
    authors = [],
    selectedAuthorId,
    onAuthorClick,
}) {
    if (!authors.length) {
        return (
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5}}>
                <Typography variant="body2" color="text.secondary" sx={{minWidth: '150px', flexShrink: 0}}>
                    Authors:
                </Typography>
                <Typography variant="body1" color="text.disabled" sx={{flex: 1, minWidth: 0}}>
                    Authors are generated from text attribution.
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 1.5}}>
            <Typography variant="body2" color="text.secondary" sx={{minWidth: '150px', pt: 0.5, flexShrink: 0}}>
                Authors:
            </Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{flex: 1, minWidth: 0}}>
                {authors.map((author) => {
                    const isAI = author.uid === 'ai' || author.isAI;
                    const isSelected = selectedAuthorId === author.uid;
                    const userColor = generateUserColor(author.uid);

                    return (
                        <Chip
                            key={author.uid}
                            avatar={
                                isAI ? (
                                    <Avatar sx={{bgcolor: 'white'}}>
                                        <SmartToyIcon sx={{fontSize: 16}}/>
                                    </Avatar>
                                ) : author.uid ? (
                                    <UserAvatar user={author} userId={author.uid}/>
                                ) : (
                                    <Avatar sx={{bgcolor: userColor}}>
                                        {author.displayName?.charAt(0) || '?'}
                                    </Avatar>
                                )
                            }
                            label={author.displayName || (isAI ? AI_AUTHOR.displayName : 'Unknown')}
                            onClick={onAuthorClick ? () => onAuthorClick(author.uid) : undefined}
                            clickable={Boolean(onAuthorClick)}
                            variant={isSelected ? 'filled' : 'outlined'}
                            sx={{
                                borderColor: isSelected ? userColor : undefined,
                                bgcolor: isSelected ? `${userColor}22` : undefined,
                                borderWidth: isSelected ? 2 : 1,
                                '&:hover': onAuthorClick ? {bgcolor: `${userColor}33`} : undefined,
                            }}
                        />
                    );
                })}
            </Stack>
        </Box>
    );
}
